import React from 'react';
import styles from './BudgetSection.module.css';

/** Bloco do orçamento: ícone, título, uma linha de apoio e o conteúdo. */
function BudgetSection({ icon, title, subtitle, aside, children }) {
  return (
    <section className={styles.card}>
      <header className={styles.header}>
        <span className={styles.icon}>{icon}</span>
        <div className={styles.titleBlock}>
          <h3 className={styles.title}>{title}</h3>
          {subtitle && <span className={styles.subtitle}>{subtitle}</span>}
        </div>
        {aside && <div className={styles.aside}>{aside}</div>}
      </header>
      <div className={styles.body}>{children}</div>
    </section>
  );
}

export default BudgetSection;
